import { render, staticRenderFns } from "./addSuggest.vue?vue&type=template&id=3ca0a73b&scoped=true&"
import script from "./addSuggest.vue?vue&type=script&lang=js&"
export * from "./addSuggest.vue?vue&type=script&lang=js&"
import style0 from "./addSuggest.vue?vue&type=style&index=0&id=3ca0a73b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca0a73b",
  null
  
)

export default component.exports